@import url("../../semantic/color.css");
@import url("../../semantic/typography.css");
@import url("../../semantic/sizing.css");
@import url("../../semantic/layering.css");

/* Identity token: a color-keyed initials placeholder, or a profile image overlaid on it.
 * person = circle, entity = rounded square. */

.doss-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background-color: var(--placeholder-fill);
  color: contrast-color(var(--placeholder-fill));
  font-weight: var(--strong-font-weight);
  text-transform: uppercase;
  user-select: none;

  & .initials {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  & .image {
    position: absolute;
    inset: 0;
    inline-size: 100%;
    block-size: 100%;
    object-fit: cover;
    border-radius: inherit;
  }

  /* With an image: card backing and no initials, so nothing shows through a transparent logo. */
  &:has(.image) {
    background-color: var(--card-background);

    & .initials {
      display: none;
    }
  }

  &.person {
    border-radius: var(--pill-radius);
  }

  &.entity {
    border-radius: var(--surface-radius);
  }

  /* Definite square footprint from the icon-size ladder; the font is the (smaller) initials. */
  &.sm {
    inline-size: var(--icon-size-medium);
    block-size: var(--icon-size-medium);
    font-size: var(--caption-text-size);
  }

  &.md {
    inline-size: var(--icon-size-extra-large);
    block-size: var(--icon-size-extra-large);
    font-size: var(--label-size);
  }

  &.lg {
    inline-size: var(--icon-size-huge);
    block-size: var(--icon-size-huge);
    font-size: var(--extra-large-font-size);
  }

  /* Deterministic 1-of-8 identity slot. */
  &[data-avatar-slot="1"] {
    --placeholder-fill: var(--placeholder-fill-1);
  }

  &[data-avatar-slot="2"] {
    --placeholder-fill: var(--placeholder-fill-2);
  }

  &[data-avatar-slot="3"] {
    --placeholder-fill: var(--placeholder-fill-3);
  }

  &[data-avatar-slot="4"] {
    --placeholder-fill: var(--placeholder-fill-4);
  }

  &[data-avatar-slot="5"] {
    --placeholder-fill: var(--placeholder-fill-5);
  }

  &[data-avatar-slot="6"] {
    --placeholder-fill: var(--placeholder-fill-6);
  }

  &[data-avatar-slot="7"] {
    --placeholder-fill: var(--placeholder-fill-7);
  }

  &[data-avatar-slot="8"] {
    --placeholder-fill: var(--placeholder-fill-8);
  }

  /* Overflow tile ("+N") — neutral, not name-keyed. */
  &.overflow {
    background-color: var(--neutral-surface);
    color: var(--text);
  }
}

/* Overlapping stack, leftmost-on-top: children render reversed in a row-reverse row so the
 * leftmost paints last; each tucks behind its neighbor, with a surface-colored ring. */
.doss-avatar-group {
  /* How far each avatar tucks behind its left neighbor. */
  --avatar-overlap: var(--micro-spacing);

  display: inline-flex;
  flex-direction: row-reverse;
  align-items: center;

  & > .doss-avatar {
    box-shadow: 0 0 0 2px var(--card-background);

    &:not(:last-child) {
      margin-inline-start: calc(-1 * var(--avatar-overlap));
    }
  }
}
